module.exports = __webpack_public_path__ + "static/media/zoom-out-icon.de701029.svg";